// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__J4Jdx","button":"Main_button__jBC5i","logo":"Main_logo__tL-OR"};